<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="审核类型" prop="type" >
        <a-select style="width: 100%" v-model="form.type" allow-clear disabled>
          <a-select-option v-for="(item, index) in this.customDict.RelatedAuditTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="二级类型" prop="subType" >
        <a-select style="width: 100%" v-model="form.subType" allow-clear disabled>
          <a-select-option v-for="(item, index) in this.customDict.RelatedAuditSubTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="用户名称" prop="nickName" >
        <a-input v-model="form.nickName" allow-clear disabled/>
      </a-form-model-item>
      <a-form-model-item label="剧本名称" prop="scriptName" >
        <a-input v-model="form.scriptName" allow-clear disabled/>
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content" >
        <a-textarea type="textarea" v-model="form.content" :rows="contentRow(form.content)" allow-clear disabled/>
      </a-form-model-item>
      <!--      <a-form-model-item label="关系id" prop="relationId" >-->
      <!--        <a-input v-model="form.relationId" placeholder="请输入关系id" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="图片" prop="image">
        <oss-multi-upload
          v-model="form.image"
          type="img"
          :maxCount="9"
          :maxSize="10"
          :isMultiple="true"
          :isRemove="false"></oss-multi-upload>
      </a-form-model-item>
      <a-form-model-item label="视频" prop="video">
        <oss-multi-upload v-model="form.video" type="video" :maxCount="1" :maxSize="200" :isRemove="false"></oss-multi-upload>
      </a-form-model-item>
      <a-form-model-item label="是否剧透" prop="isSpoiler">
        <a-switch v-model="form.isSpoiler" disabled/>{{ form.isSpoiler ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="扮演角色" prop="scriptRole" >
        <a-input v-model="form.scriptRole" allow-clear disabled/>
      </a-form-model-item>
      <a-form-model-item label="自定义店铺名称" prop="diyShopName" >
        <a-input v-model="form.diyShopName" allow-clear disabled/>
      </a-form-model-item>
      <a-form-model-item label="用户对店铺体验" prop="manualScoreType">
        <a-select style="width: 100%" v-model="form.manualScoreType" disabled>
          <a-select-option :value="1">超棒</a-select-option>
          <a-select-option :value="2">一般</a-select-option>
          <a-select-option :value="3">较差</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="仅评分" prop="onlyRating">
        <a-switch v-model="form.onlyRating" disabled />{{ form.onlyRating ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="仅我可见" prop="onlyVisibleToMe">
        <a-switch v-model="form.onlyVisibleToMe" disabled />{{ form.onlyVisibleToMe ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="审核方式" prop="auditWay">
        <a-select v-model="form.auditWay" disabled>
          <a-select-option :value="1">自动审核</a-select-option>
          <a-select-option :value="2">手动审核</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="审核状态" prop="status" >
        <a-select style="width: 100%" v-model="form.status" placeholder="请选择审核状态" allow-clear>
          <a-select-option v-for="(item, index) in this.customDict.RelatedAuditStatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="创建时间" prop="createTime" >
        <a-date-picker style="width: 100%" v-model="form.createTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear disabled/>
      </a-form-model-item>
      <!--      <a-form-model-item label="审核时间" prop="auditTime" >-->
      <!--        <a-date-picker style="width: 100%" v-model="form.auditTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="逻辑删除标记 1:删除,0:未删除" prop="isDeleted" v-if="formType === 1">-->
      <!--        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记 1:删除,0:未删除" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="备注内容" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <!--      <a-form-model-item label="版本号" prop="version" v-if="formType === 1">-->
      <!--        <a-input v-model="form.version" placeholder="请输入版本号" />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRelatedAuditRecord, addRelatedAuditRecord, updateRelatedAuditRecord } from '@/api/user/relatedAuditRecord'
import Editor from '@/components/Editor'
import { mapGetters } from 'vuex'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssMultiUpload,
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        type: null,
        subType: null,
        userId: null,
        content: null,
        relationId: null,
        image: null,
        video: null,
        isSpoiler: undefined,
        scriptRole: undefined,
        diyShopName: undefined,
        shopExperience: undefined,

        onlyRating: undefined,
        onlyVisibleToMe: undefined,
        auditWay: undefined,
        status: 0,
        createTime: null,
        updateTime: null,
        modifier: null,
        auditTime: null,
        creator: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // type: [
        //   { required: true, message: '审核类型 1.剧评审核 2.上车认证不能为空', trigger: 'change' }
        // ],
        // userId: [
        //   { required: true, message: '用户id不能为空', trigger: 'blur' }
        // ],
        // content: [
        //   { required: true, message: '内容不能为空', trigger: 'blur' }
        // ],
        // image: [
        //   { required: true, message: '图片不能为空', trigger: 'blur' }
        // ],
        status: [
          { required: true, message: '审核状态 0.待审核 1.已审核 2.已驳回不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: { ...mapGetters(['customDict']) },
  watch: {
  },
  mounted () {
  },
  methods: {
    contentRow (value) {
      if (value == null) {
        return 1
      } else if (value.length > 1000) {
        return 10
      } else {
        return Math.ceil(value.length / 200) * 4
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        subType: null,
        userId: null,
        content: null,
        relationId: null,
        image: null,
        video: null,
        isSpoiler: undefined,
        scriptRole: undefined,
        diyShopName: undefined,
        shopExperience: undefined,

        onlyRating: undefined,
        onlyVisibleToMe: undefined,
        auditWay: undefined,
        status: 0,
        createTime: null,
        updateTime: null,
        modifier: null,
        auditTime: null,
        creator: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRelatedAuditRecord(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRelatedAuditRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRelatedAuditRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
